module.exports = __webpack_public_path__ + "img/activity.527bf606.png";